// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__fae5T","icon":"SortAdornment_icon__rl4Uw","up":"SortAdornment_up__3g8jV","down":"SortAdornment_down__arKzQ","active":"SortAdornment_active__ubkjt"};